import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { useI18n } from "@/i18n";
import { getStorefrontSettings } from "@/lib/api";
import BrandMark from "./BrandMark";
import TikTokIcon from "./TikTokIcon";

export default function Footer() {
  const { t } = useI18n();
  const [tikTokUrl, setTikTokUrl] = useState("");
  const [contactEmail, setContactEmail] = useState("");

  useEffect(() => {
    getStorefrontSettings().then((settings) => {
      setTikTokUrl(settings.tiktok_url);
      setContactEmail(settings.contact_email);
    }).catch(() => undefined);
  }, []);

  return (
    <footer className="minimal-footer">
      <div className="container minimal-footer-inner">
        <BrandMark compact />
        <nav>
          <div className="minimal-footer-primary-links">
            <Link to="/gallery">{t.nav.shopAll}</Link>
            <Link to="/gallery/original">{t.nav.original}</Link>
            <Link to="/gallery/print">{t.nav.print}</Link>
          </div>
          <div className="minimal-footer-secondary-links">
            <Link to="/contact">{t.nav.contact}</Link>
            {contactEmail && <a href={`mailto:${contactEmail}`} className="minimal-footer-email" aria-label={t.contact.email}><Mail size={19} /></a>}
            {tikTokUrl && <a href={tikTokUrl} target="_blank" rel="noopener noreferrer" className="minimal-footer-tiktok" aria-label="TikTok"><TikTokIcon size={21} /></a>}
          </div>
        </nav>
      </div>
      <div className="container minimal-footer-legal">
        <span>© {new Date().getFullYear()} Dalila Di Maria</span>
        <Link to="/shipping-policy" className="text-xs">{t.footer.shippingPolicy}</Link>
        <Link to="/return-policy" className="text-xs">{t.footer.returnPolicy}</Link>
        <Link to="/privacy-policy" className="text-xs">{t.footer.privacy}</Link>
        <span>{t.footer.rights}</span>
      </div>
    </footer>
  );
}
